module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pill-tabs"
    }
  }, [_c('div', {
    staticClass: "tab-header",
    attrs: {
      "id": "tabs"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tab-section",
      "data-tabs": "tabs"
    }
  }, _vm._l((_vm.tabs), function(tab, idx) {
    return _c('li', {
      key: idx,
      staticClass: "nav-item",
      class: {
        'nav-item active': _vm.activeTab === Object.keys(tab)[0]
      }
    }, [_c('a', {
      staticClass: "nav-link",
      attrs: {
        "id": idx,
        "data-toggle": "pill"
      },
      on: {
        "click": function($event) {
          _vm.switchTab(Object.keys(tab)[0])
        }
      }
    }, [_vm._t(_vm.tabHeadSlotName(Object.keys(tab)[0]), [_vm._v(_vm._s(Object.values(tab)[0]))])], 2)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t(_vm.tabPanelSlotName)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec19fad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/tab.vue
// module id = 1062
// module chunks = 0